import React, {ReactComponentElement, useEffect, useState} from 'react';

import Checkers from '../../../../../helpers/class/Checkers';
import CustomModal from '../../../../CustomModal';
import ModalServices from '../modals/ModalServices';

import Included from './included/Included';
import Ondemand from './ondemand/Ondemand';
import RightModal from "../../../properties/partials/RightModal";
import ContentWrapper from "../../../properties/partials/ContentWrapper";
import SwipperWrapper from "../../../properties/partials/SwipperWrapper";
import SimpleContent from "../../../properties/partials/SImpleContent";
import AttributesList from "../../../properties/partials/AttributesList";
import FeaturesList from "../../../properties/partials/FeaturesList";
import {useSelector} from "react-redux";
import {fetchBuilderSettingByKey} from "../../../../../helpers/MethodHelper";
import {Swiper, SwiperSlide} from "swiper/react";
import SingleServiceContent from "./SingleServiceContent";
import {AnyComponent} from "styled-components/native/dist/types";
import cloneDeep from 'lodash/cloneDeep'

interface ServiceContentProps  {
    type: string
    services: Array<any>
    layout?: string
}

const ServiceContent = ({ type, services } : ServiceContentProps ) => {


    const servicesLimit = useSelector(
        state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_propertyview_services_limit')
    );

    const [currentServicesLimit, setCurrentServicesLimit] = useState(servicesLimit)


    const servicesViewMoreButton = useSelector(
        state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_propertyview_services_view_more_button')
    );

    const showAllHandler = () => {
        if ( servicesLimit==currentServicesLimit ) {
            setCurrentServicesLimit(null)
        } else {
            setCurrentServicesLimit(servicesLimit)
        }
    }

    const servicesOnRequestLayout = useSelector(state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_propertyview_onrequest_services'));

    const servicesSpecialLayout = useSelector(state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_propertyview_special_services'));

    const servicesIncludedLayout = useSelector(state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_propertyview_included_services'));

    const layoutHandler = (type) => {
        if (type == 'included') {
            return servicesIncludedLayout
        } else if (type == 'ondemand') {
            return servicesOnRequestLayout
        } else if (type == 'featured') {
            return servicesSpecialLayout
        }
    }

    const layout = layoutHandler(type)

    const useSwiper = layout == "carousel"

    const serviceComponent : Array<ReactComponentElement<AnyComponent>> = []

    services.map((service, index) => {
        serviceComponent.push(<SwiperSlide key={index}><SingleServiceContent service={service} layout={layout} useSwiper={true}/></SwiperSlide>)
    })

    return (
        <>
            {
                useSwiper ?
                    <>
                        {
                            <SwipperWrapper
                                key={'services-swiper-'+type}
                                imageSlider={false}
                                htmlSlides={serviceComponent}
                                paginationBulletsEnabled={false}
                                slidesPerView={3.2}
                                slidesPerViewLg={3}
                                slidesPerViewMd={3}
                                slidesPerViewSm={2}
                                slidesPerViewXs={1.4}
                                spaceBetween={20}
                                enableLoop={false}
                                galleryHeight={'auto'}
                                wrapperClassName={'d-navigation '}
                                enableFancyBox={false}
                                centeredSlides={false}
                            />
                        }
                    </>
                    :
                    <div className="row pt-4">
                        {
                            services.map((service, index) => {
                                if ( currentServicesLimit!=null && index>=currentServicesLimit ) {
                                    return
                                }

                                return (<SingleServiceContent key={index} service={service} layout={layout}/>)
                            })
                        }
                        {
                            Checkers.isValidArray(services) && (currentServicesLimit!=null && currentServicesLimit<services.length)  ?
                                <div className="row clearfix text-center p-t-30 m-b-60">
                                    <div className="col-12">
                                        <span onClick={showAllHandler}
                                              className="btn btn-rounded btn-black btn-bordered">
                                            {servicesViewMoreButton}
                                        </span>
                                    </div>
                                </div>
                                :
                                <></>

                        }
                    </div>
            }
        </>
    )
}

export default ServiceContent;
